import { DetailSectionWrapper, QuestionLayout } from '@exam-management/qcontent-management';
import { useQuestionCreationTaskDetails } from '@exam-management/question-creation-task-details';
import {
  LocationSection,
  SingleQuestionDetailsSection,
  SingleQuestionHeader,
  SingleQuestionInformationSection,
  SingleQuestionPropertiesSection,
  SingleQuestionCreationEditForm,
  useGetQBSLevelAndLevelItemsForTask,
  useSingleQuestionDetails,
  SingleQuestionCreationEditFormActions,
} from '@exam-management/question-creation-task-question-management';
import { Flex, Loading, PaperSection } from '@shared/components';

export default function QuestionCreationTaskQuestionDetails() {
  const { task } = useQuestionCreationTaskDetails();
  const { singleQuestion } = useSingleQuestionDetails();

  const {
    qbsLevelItems,
    qbsLevels,
    loading: isGettingQBSLevel,
  } = useGetQBSLevelAndLevelItemsForTask(singleQuestion.refQBankStructureId, task.id);

  if (isGettingQBSLevel) return <Loading sx={{ height: '100%' }} />;
  return (
    <SingleQuestionCreationEditForm
      qbsLevels={qbsLevels}
      qbsLevelItems={qbsLevelItems}
      taskId={task.id}
    >
      <SingleQuestionHeader />
      <QuestionLayout
        sideContent={<LocationSection qbsLevels={qbsLevels} qbsLevelItems={qbsLevelItems} />}
      >
        <Flex sx={{ width: '100%', flexDirection: 'column', gap: (theme) => theme.spacing(6) }}>
          <PaperSection title='Question Details'>
            <DetailSectionWrapper>
              <SingleQuestionInformationSection />
              <SingleQuestionDetailsSection />
              <SingleQuestionPropertiesSection />
            </DetailSectionWrapper>
          </PaperSection>
          <SingleQuestionCreationEditFormActions />
        </Flex>
      </QuestionLayout>
    </SingleQuestionCreationEditForm>
  );
}
